import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m11.02 10.2 3.45-2.25q.425-.272.425-.748 0-.477-.425-.752L11.02 4.2a.85.85 0 0 0-.925-.05q-.475.25-.475.8v4.5q0 .55.475.8.474.25.925-.05m-4.4 4.2q-.825 0-1.313-.488-.487-.486-.487-1.312V1.8q0-.825.487-1.312Q5.795 0 6.62 0h10.8q.825 0 1.312.488.488.487.488 1.312v10.8q0 .825-.488 1.313-.487.487-1.312.487zm0-1.8h10.8V1.8H6.62zm-3.125 6.6a1.7 1.7 0 0 1-1.325-.363 1.76 1.76 0 0 1-.7-1.187L.02 6.925a1.71 1.71 0 0 1 .362-1.336A1.79 1.79 0 0 1 1.595 4.9l.45-.05q.424-.05.7.213a.9.9 0 0 1 .275.68.9.9 0 0 1-.213.602.86.86 0 0 1-.562.305l-.425.05 1.425 10.7 11.55-1.55a.9.9 0 0 1 .683.174.85.85 0 0 1 .342.601.9.9 0 0 1-.173.676.86.86 0 0 1-.602.349z"
    }, null, -1)
  ]))]))
}
export default { render: render }